import { SendConsentFormsArgs } from '@hb/shared'
import { httpsCallable } from 'firebase/functions'
import { functions } from './functions'

export const sendConsentForms = httpsCallable<SendConsentFormsArgs>(functions, 'sendConsentForms')
